
import { isUpdatePossiable } from '@/api/reservationSchedulePart';
import { ReservationItemModule } from '@/store/modules/reservationItem';
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import DateForm from './AddDateForm.vue';

@Component({
  components: {
    DateForm,
  },
})
export default class extends Vue {
  get schedulePart() {
    return ReservationItemModule.form.schedulePart;
  }

  private formVisible = false;

  private selectedItem = null;

  private selectedIndex = null;

  private index: any = null;

  private tableKey = 0;

  private typeList = [];

  private closeDataFormDialog() {
    this.formVisible = false;
    this.tableKey += 1;
  }

  private deleteType(idx: number) {
    const schedulePart = this.schedulePart[idx];
    this.$confirm('해당 기간에 예약자가 있는 경우 삭제하실 수 없습니다.', '경고', {
      cancelButtonText: '취소',
      confirmButtonText: '삭제',
      type: 'warning',
    }).then(() => {
      isUpdatePossiable({
        itemUid: this.$route.params.uid,
        startDate: schedulePart.startDate,
        endDate: schedulePart.endDate,
      }).then((res) => {
        if (res.data) {
          const orgData = [...this.schedulePart];
          orgData.splice(idx, 1);
          ReservationItemModule.form.schedulePart = [...orgData];
          this.$emit('deleteSchedulePart');
        } else {
          this.$message({
            message: '해당 일정에 이미 예약된 이용자가 있어 삭제가 불가능합니다.',
            type: 'warning',
          });
        }
      });
    });
  }

  private handleType(item: any, index: any) {
    this.formVisible = !this.formVisible;
    this.selectedItem = item;
    this.selectedIndex = index;
  }

  private close() {
    this.$emit('close');
  }
}
